/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWatchlistCommand } from '../../models/create-watchlist-command';
import { WatchlistModelResult } from '../../models/watchlist-model-result';

export interface ApiWatchlistCreatePost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params {
      body?: CreateWatchlistCommand
}

export function apiWatchlistCreatePost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiWatchlistCreatePost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<WatchlistModelResult>> {
  const rb = new RequestBuilder(rootUrl, apiWatchlistCreatePost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WatchlistModelResult>;
    })
  );
}

apiWatchlistCreatePost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse.PATH = '/api/watchlist/create';
